import React from "react";
import { Label, Stack } from "@fluentui/react";
import { Link } from "react-router";
import colors from "../colors.scss";
import { store } from "../../store";

export enum LabelDate {
    TODAY,
    YESTERDAY,
    OLDER,
}

export interface NotificationLabelProps {
    date: LabelDate;
    renderMarkAllRead: boolean;
    onClick: () => void;
}

/// This component is displayed in the notification Panel.
/// It is used to devide the notifications into date-based subsections.
/// I.e "Today", "Yesterday" or "Older".
/// Depending on the `renderMarkAllRead` prop, a "Mark all as read" button will be displayed.
/// Once that button is clicked, the `props.onClick` callback will be called.

export class NotificationLabel extends React.Component<NotificationLabelProps> {
    constructor(props: NotificationLabelProps) {
        super(props);
    }

    render(): JSX.Element {
        let label;
        if (this.props.date === LabelDate.TODAY) {
            label = store.i18n.t("component.notificationLabel.today").toUpperCase();
        } else if (this.props.date === LabelDate.YESTERDAY) {
            label = store.i18n.t("component.notificationLabel.yesterday").toUpperCase();
        } else {
            label = store.i18n.t("component.notificationLabel.older").toUpperCase();
        }

        let markAllRead = <></>;
        if (this.props.renderMarkAllRead) {
            markAllRead = (
                <Stack.Item>
                    <Link
                        style={{ fontSize: 14, color: colors["secondary10"], textAlign: "right" }}
                        to=""
                        onClick={this.props.onClick}
                    >
                        {store.i18n.t("component.notificationLabel.markAllRead")}
                    </Link>
                </Stack.Item>
            );
        }

        return (
            <Stack horizontal style={{ padding: 5, marginTop: 10 }}>
                <Stack.Item grow={5}>
                    <Label style={{ color: colors["secondary10"] }}>{label}</Label>
                </Stack.Item>
                {markAllRead}
            </Stack>
        );
    }
}
